import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Elements } from 'react-stripe-elements'
import selectors from '../../../store/shared/selectors'
import BlankCard from '../../../components/ui/cards/BlankCard'
import PageTitleBar from '../../../components/ui/navigation/PageTitleBar'
import accountUtils from '../../../utils/account/accountUtils'
import UpdatePaymentForm from './components/UpdatePaymentForm'

class AuthenticatedUpdatePaymentIndex extends Component {
  static propTypes = {
    user: PropTypes.any,
  }

  render() {
    const { user } = this.props

    const isAbleToPay = accountUtils.isAbleToAddPayment(user)

    return (
      <div>
        <PageTitleBar content="Update Payment Method" />
        <div className="max-1200">
          <div>
            <div className="col-md-10 offset-md-1" style={{ paddingTop: 20 }}>
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="row">
                  <div className="col-md-6">
                    <BlankCard notCard delay={2} title="&nbsp;">
                      <div className="alert alert-dark" role="alert">
                        <h4 className="alert-heading">
                          Subscription Payment Failed
                        </h4>
                        <br />
                        {isAbleToPay ? (
                          <div>
                            <h6>
                              Our payment processor{' '}
                              <a href="https://stripe.com">Stripe</a> couldn't
                              process your last payment.
                            </h6>
                            <br />
                            <h6>Update your payment method to continue.</h6>
                            <hr />
                            <h6 className="mb-0 small">
                              Questions?{' '}
                              <a
                                href="mailto:support@steppingblocks.com"
                                className="alert-link"
                              >
                                Contact us.
                              </a>
                            </h6>
                          </div>
                        ) : (
                          <h6>
                            Contact your system administrator to reactivate your
                            account.
                          </h6>
                        )}
                      </div>
                    </BlankCard>
                  </div>
                  {isAbleToPay && (
                    <div className="col-md-5">
                      <Elements>
                        <BlankCard title="New Payment Method" delay={2.3}>
                          <UpdatePaymentForm />
                        </BlankCard>
                      </Elements>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: selectors.getCurrentUser(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(
  AuthenticatedUpdatePaymentIndex,
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UpdatePayment/AuthenticatedUpdatePaymentIndex.js